<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingContractConfirmation$ | async"
  (back)="service.goToPreviousStep()"
  (forward)="submit()"
  [buttonLabel]="'child-onboarding.conclusion-of-contract.btn' | transloco"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.conclusion-of-contract.headline' | transloco }}</p>
  <child-onboarding-docs [onboardingId]="store.selectedChildOnboarding()?.onboardingId" />
  <hr />
  <web-components-trading-session (authorizationState)="setSessionAuthState($event)" />
  <p class="zero-text p-base-med mt-4">{{ 'child-onboarding.conclusion-of-contract.hint' | transloco }}</p>
</child-onboarding-container>
